export default {
  privacyPolicy: '18012016-094011-2673',
  termsAndConditionsSimplified: '18012016-094056-4209',
  cookiePolicy: '18012016-094303-5271',
  regusGroupCompanies: '21022019-105513-0023',
  copyright: '29072019-132337-2173',
  allRightsReserved: '29072019-132338-5506',
  selectLocation: '28102025-085406-0000',
  location: '22112016-134248-8296',
  loading: 'Loading...',
  next: '01092015-144247-2681'
};
